// BoostSocial Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ─── Sticky Header ───────────────────────────────────────
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ─── Dropdown Nav ────────────────────────────────────────
  var navTrigger = document.querySelector('.nav-trigger');
  var dropdownMenu = document.getElementById('platforms-menu');
  if (navTrigger && dropdownMenu) {
    navTrigger.addEventListener('click', function () {
      var isOpen = dropdownMenu.classList.toggle('open');
      navTrigger.setAttribute('aria-expanded', isOpen);
    });
    document.addEventListener('click', function (e) {
      if (!navTrigger.contains(e.target) && !dropdownMenu.contains(e.target)) {
        dropdownMenu.classList.remove('open');
        navTrigger.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dropdownMenu.classList.remove('open');
        navTrigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ─── Mobile Menu ─────────────────────────────────────────
  var mobileToggle = document.getElementById('mobile-menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      mobileToggle.classList.toggle('active');
    });
  }

  // ─── Persistent Order Counter ────────────────────────────
  //
  // Purely time-based — no localStorage, no cookies.
  // count = BASE_COUNT + floor((now - ANCHOR_MS) * RATE_PER_MS)
  //
  // Works identically on every device, browser, cleared cache,
  // incognito mode, or returning days/weeks later. It can never
  // reset because it's derived entirely from the system clock.
  //
  // Rate: avg 1.5 orders every 4.5 s ≈ 20 orders/min.
  // On-screen tick fires every 2–7 s and adds 1 or 2.
  //
  (function () {
    var el = document.getElementById('orders-counter');
    if (!el) return;

    // Fixed anchor — Jan 1 2025 00:00:00 UTC. Never change this.
    var ANCHOR_MS   = 1735689600000;
    var BASE_COUNT  = 1254346;
    // ~20 orders per minute expressed in orders-per-millisecond
    var RATE_PER_MS = 20 / 60000;

    function trueCount() {
      var elapsed = Math.max(0, Date.now() - ANCHOR_MS);
      return Math.floor(BASE_COUNT + elapsed * RATE_PER_MS);
    }

    function fmt(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Seed display at the mathematically correct current value
    var displayed = trueCount();
    el.textContent = fmt(displayed);

    // Live tick: wait 2–7 s, bump +1 or +2, clamp to trueCount
    function tick() {
      var delay    = 2000 + Math.random() * 5000;  // 2 000–7 000 ms
      var increase = Math.random() < 0.5 ? 1 : 2; // 1 or 2 orders

      setTimeout(function () {
        displayed += increase;
        // Never let displayed fall behind the real time-based value
        var real = trueCount();
        if (displayed < real) displayed = real;

        el.textContent = fmt(displayed);
        tick(); // schedule next tick
      }, delay);
    }

    tick();
  }());

  // ─── Cart Add Feedback ───────────────────────────────────
  var productForm = document.getElementById('product-form');
  var addToCartBtn = document.getElementById('add-to-cart-btn');
  if (productForm && addToCartBtn) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      // Validate URL field
      var urlInput = productForm.querySelector('input[name="properties[Service URL]"]');
      if (urlInput && !urlInput.value.trim()) {
        urlInput.focus();
        urlInput.style.borderColor = 'rgba(248, 113, 113, 0.7)';
        urlInput.style.boxShadow = '0 0 0 3px rgba(248, 113, 113, 0.15)';
        var hint = urlInput.nextElementSibling;
        if (hint) {
          hint.textContent = '⚠ Please enter your profile or post URL before adding to cart.';
          hint.style.color = '#f87171';
        }
        setTimeout(function() {
          urlInput.style.borderColor = '';
          urlInput.style.boxShadow = '';
          if (hint) { hint.textContent = 'Paste the link to your profile or post where you want the service delivered.'; hint.style.color = ''; }
        }, 3000);
        return;
      }

      var originalText = addToCartBtn.innerHTML;
      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      addToCartBtn.style.background = 'linear-gradient(135deg, #16a34a, #15803d)';

      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badge = document.querySelector('.cart-badge');
          if (cart.item_count > 0) {
            if (badge) {
              badge.textContent = cart.item_count;
            } else {
              var cartLink = document.querySelector('.header-cart');
              if (cartLink) {
                var newBadge = document.createElement('span');
                newBadge.className = 'cart-badge';
                newBadge.textContent = cart.item_count;
                cartLink.appendChild(newBadge);
              }
            }
          }
        })
        .catch(function () {})
        .finally(function () {
          setTimeout(function () {
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML = originalText;
            addToCartBtn.style.background = '';
          }, 2000);
        });
    });
  }

  // ─── Scroll Reveal Animation ─────────────────────────────
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.product-card, .platform-card, .why-feature');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease ' + (i % 6 * 0.07) + 's, transform 0.5s ease ' + (i % 6 * 0.07) + 's';
      observer.observe(el);
    });
  }

});
